import { Bold } from "@/components/Typography";

const highlightText = (text: string, keywords?: string[]): React.ReactNode => {
  if (!keywords?.length || !text) {
    return text;
  }

  const regex = new RegExp(`(${keywords.join("|")})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) => {
    if (part?.match(regex)) {
      return <Bold key={index}>{part}</Bold>;
    }
    return <span key={index}>{part}</span>;
  });
};

const OnboardingInstructions = ({
  values,
  highlightedKeywords,
}: IMatConfigurationInstructionsProperty) => {
  if (!values || values.length === 0) {
    return null;
  }

  return (
    <ol className="list-outside list-decimal space-y-5 pl-20">
      {values.map((instruction, index) => (
        <li key={index}>{highlightText(instruction, highlightedKeywords)}</li>
      ))}
    </ol>
  );
};

export default OnboardingInstructions;
